import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton, Modal, Paper, useMediaQuery, useTheme } from "@mui/material";

const defaultStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "calc(100vw - 32px)",
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "#fcfcfc",
  borderRadius: "16px",
  boxShadow:
  "rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px",
  p: 4,
};

// Tablets: the percentage widths pages ask for get too narrow
const tabletStyle = {
  width: "min(92vw, 720px)",
};

// Phones: full screen, closed with the button since there is no backdrop
const mobileStyle = {
  top: 0,
  left: 0,
  transform: "none",
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "100%",
  borderRadius: 0,
  p: 2,
  pt: 7,
};

const CustomModal = ({ isOpen, onClose, sx, children }) => {
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Paper sx={{
        ...defaultStyle,
        ...sx,
        ...(isTablet ? tabletStyle : {}),
        ...(isPhone ? mobileStyle : {}),
      }}>
        <IconButton
          onClick={onClose}
          aria-label="Close"
          size="small"
          sx={{ position: "absolute", top: 12, right: 12, zIndex: 1 }}
        >
          <CloseRoundedIcon />
        </IconButton>
        {children}
      </Paper>
    </Modal>
  );
};

export default CustomModal;
